import { render, staticRenderFns } from "./html-wrapper.vue?vue&type=template&id=d8688052&"
import script from "./html-wrapper.vue?vue&type=script&lang=js&"
export * from "./html-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports